<template>
  <li :class="{ 'navigation-item': starrable }">
    <NavigationLink
      :route="route"
      :suggested="suggested"
    />
    <button
      v-if="starrable"
      type="button"
      class="navigation-item__star"
      :class="{ 'is-favorite': favorite }"
      :aria-pressed="String(favorite)"
      :aria-disabled="String(blocked)"
      :aria-label="starName"
      :title="starLabel"
      @click="navigationFavorites.toggle(route)"
    >
      <i
        :class="favorite ? 'fas fa-star' : 'far fa-star'"
        aria-hidden="true"
      />
    </button>
  </li>
</template>

<script>
import NavigationLink from '@/components/Navigation/NavigationLink.vue';

export default {
  name: 'NavigationItem',
  components: {
    NavigationLink,
  },
  inject: {
    navigationFavorites: { default: null },
  },
  props: {
    route: {
      type: Object,
      required: true,
    },
    suggested: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    starrable() {
      return Boolean(this.navigationFavorites?.enabled()) && typeof this.route['menu-item'] === 'string';
    },
    favorite() {
      return this.starrable && this.navigationFavorites.has(this.route);
    },
    blocked() {
      return this.starrable && !this.favorite && this.navigationFavorites.full();
    },
    starName() {
      return `Favoritar ${this.route.text}, ${this.route['menu-item']}`;
    },
    starLabel() {
      if (this.favorite) return `Remover ${this.route.text} dos favoritos`;
      if (this.blocked) return `${this.starName}: limite de favoritos atingido`;

      return this.starName;
    },
  },
};
</script>
